const root = document.querySelector('[data-product]');
const dataEl = document.querySelector('[data-product-json]');

function formatMoney(cents, format = '₹{{amount}}') {
  const value = Number(cents) / 100;
  const group = (amount, decimals, thousands, decimal) => {
    const fixed = amount.toFixed(decimals);
    const [whole, fraction] = fixed.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? `${grouped}${decimal}${fraction}` : grouped;
  };
  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
    switch (key) {
      case 'amount_no_decimals':
        return group(value, 0, ',', '.');
      case 'amount_with_comma_separator':
        return group(value, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return group(value, 0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return group(value, 2, "'", '.');
      default:
        return group(value, 2, ',', '.');
    }
  });
}

if (root && dataEl) {
  const data = JSON.parse(dataEl.textContent);
  const strings = data.strings;
  const form = document.getElementById(root.dataset.formId);
  const select = form?.querySelector('[data-variant-select]');
  const picker = root.querySelector('[data-variant-picker]');
  const fieldsets = picker ? [...picker.querySelectorAll('[data-option-index]')] : [];
  const addButton = form?.querySelector('[data-add-button]');
  const stickyBar = document.querySelector('[data-sticky-buy]');
  const stickyAdd = stickyBar?.querySelector('[data-sticky-add]');
  const track = root.querySelector('[data-gallery-track]');
  const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
  const lightbox = root.querySelector('[data-lightbox]');

  if (picker && select) select.hidden = true;

  const selectedOptions = () => fieldsets.map((fs) => fs.querySelector('input:checked')?.value);
  const findVariant = (options) =>
    data.variants.find((variant) => variant.options.every((value, index) => value === options[index]));

  function priceHTML(variant, extraClass) {
    const current = formatMoney(variant.price, data.moneyFormat);
    if (variant.compareAtPrice > variant.price) {
      const percent = Math.floor(((variant.compareAtPrice - variant.price) * 100) / variant.compareAtPrice);
      return `<div class="price ${extraClass}">
        <span class="visually-hidden">${strings.salePrice}</span>
        <span class="price__current">${current}</span>
        <span class="price__compare">${strings.regularPrice} <s>${formatMoney(variant.compareAtPrice, data.moneyFormat)}</s></span>
        ${percent > 0 ? `<span class="price__badge">${strings.percentOff.replace('[percent]', percent)}</span>` : ''}
      </div>`;
    }
    return `<div class="price ${extraClass}"><span class="visually-hidden">${strings.price}</span><span class="price__current">${current}</span></div>`;
  }

  function setButtons(variant) {
    const label = !variant ? strings.unavailable : variant.available ? strings.addToCart : strings.soldOut;
    const disabled = !variant || !variant.available;
    [addButton, stickyAdd].forEach((button) => {
      if (!button) return;
      button.textContent = label;
      button.disabled = disabled;
    });
  }

  function showMedia(mediaId, smooth = true) {
    if (!track || !mediaId) return;
    const slide = track.querySelector(`[data-media-id="${mediaId}"]`);
    if (!slide) return;
    track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    setActiveThumb(String(mediaId));
  }

  function updateAvailability(options) {
    fieldsets.forEach((fieldset, index) => {
      fieldset.querySelector('[data-selected-value]').textContent = options[index] || '';
      fieldset.querySelectorAll('input').forEach((input) => {
        const label = fieldset.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        const available = data.variants.some(
          (variant) =>
            variant.available &&
            variant.options[index] === input.value &&
            variant.options.every((value, other) => other === index || value === options[other])
        );
        label?.classList.toggle('is-unavailable', !available);
      });
    });
  }

  function update() {
    const options = selectedOptions();
    const variant = findVariant(options);
    updateAvailability(options);
    setButtons(variant);
    if (!variant) return;

    if (select) select.value = String(variant.id);
    const priceEl = root.querySelector('[data-price]');
    if (priceEl) priceEl.innerHTML = priceHTML(variant, 'product__price');
    const stickyPrice = stickyBar?.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.innerHTML = priceHTML(variant, '');

    const sku = root.querySelector('[data-sku]');
    if (sku) {
      sku.hidden = !variant.sku;
      sku.querySelector('[data-sku-value]').textContent = variant.sku || '';
    }

    const stock = root.querySelector('[data-stock]');
    if (stock && data.showStock) {
      const threshold = Number(stock.dataset.threshold);
      const show = variant.tracked && variant.stock > 0 && variant.stock <= threshold;
      stock.hidden = !show;
      if (show) stock.textContent = strings.lowStock.replace('[count]', variant.stock);
    }

    showMedia(variant.mediaId);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState(window.history.state, '', url);
  }

  picker?.addEventListener('change', update);
  select?.addEventListener('change', () => {
    const variant = data.variants.find((v) => String(v.id) === select.value);
    if (variant) setButtons(variant);
  });

  /* Quantity steppers */
  root.querySelector('[data-product-qty]')?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-step]');
    if (!button) return;
    const input = button.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.step));
  });

  /* Gallery */
  function setActiveThumb(mediaId) {
    thumbs.forEach((thumb) => {
      if (thumb.dataset.galleryThumb === mediaId) thumb.setAttribute('aria-current', 'true');
      else thumb.removeAttribute('aria-current');
    });
  }

  thumbs.forEach((thumb) => thumb.addEventListener('click', () => showMedia(thumb.dataset.galleryThumb)));

  if (track && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActiveThumb(entry.target.dataset.mediaId);
        });
      },
      { root: track, threshold: 0.6 }
    );
    track.querySelectorAll('[data-media-id]').forEach((slide) => observer.observe(slide));
  }

  root.addEventListener('click', (event) => {
    const zoom = event.target.closest('[data-gallery-zoom]');
    if (zoom && lightbox) {
      lightbox.showModal();
      document.documentElement.classList.add('scroll-lock');
      const target = lightbox.querySelector(`[id$="-${zoom.dataset.galleryZoom}"]`);
      target?.scrollIntoView({ block: 'start' });
      return;
    }
    const deferred = event.target.closest('[data-deferred-media-button]');
    if (deferred) {
      const wrapper = deferred.closest('[data-deferred-media]');
      const template = wrapper.querySelector('template');
      wrapper.replaceChildren(template.content.cloneNode(true));
    }
  });

  lightbox?.addEventListener('click', (event) => {
    if (event.target.closest('[data-lightbox-close]') || event.target === lightbox) lightbox.close();
  });
  lightbox?.addEventListener('close', () => document.documentElement.classList.remove('scroll-lock'));

  /* Sticky mobile buy bar: shows once the main Add to cart button has scrolled above the viewport */
  if (stickyBar && addButton) {
    const mobile = window.matchMedia('(max-width: 989px)');
    let ticking = false;
    const update = () => {
      ticking = false;
      const show = mobile.matches && addButton.getBoundingClientRect().bottom < 0;
      if (stickyBar.hidden === !show) return;
      stickyBar.hidden = !show;
      document.body.classList.toggle('has-sticky-buy', show);
    };
    const schedule = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    window.addEventListener('scroll', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    update();
  }
}

/* Related products: fetched only when the section approaches the viewport */
document.querySelectorAll('[data-recommendations]').forEach((container) => {
  const load = async () => {
    try {
      const response = await fetch(container.dataset.url);
      if (!response.ok) {
        container.remove();
        return;
      }
      const html = await response.text();
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-recommendations]');
      if (next && next.querySelector('.product-grid__item')) container.replaceWith(next);
      else container.remove();
    } catch {
      container.remove();
    }
  };
  if (!('IntersectionObserver' in window)) {
    load();
    return;
  }
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) return;
      observer.disconnect();
      load();
    },
    { rootMargin: '400px 0px' }
  );
  observer.observe(container);
});
